import { Component, ContentChild, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { LocalStorageService } from '../../../../core/services/local-storage.service';
import { OptionalDescriptionDirective } from '../../../directives/optional-description.directive';
import { ModalService } from '../../../components/nz-modal-service/modal.service';
import { ScreenManagerService } from '../../../../core/services/screen-manager.service';
import { TerminalManagementService } from '../../../../core/services/terminal-management.service';

@Component({
    selector: 'ng-mf-swap-validation-failure',
    templateUrl: './swap-validation-failure.component.html',
    styleUrls: ['../moniepoint-failure-modal/moniepoint-failure-modal.component.scss'],
})
export class SwapValidationFailureComponent {
    isMobile = false;
    readonly aggregators = 'aggregators';

    context = '';
    @Input() reason = '';
    @Output() closeModal = new EventEmitter<boolean>();
    @ContentChild(OptionalDescriptionDirective) optionalDescription?: OptionalDescriptionDirective;

    constructor(
        private router: Router,
        private terminalManagementService: TerminalManagementService,
        private localStorage: LocalStorageService,
        private authenticationService: AuthenticationService,
        private modalService: ModalService,
        private screenManagerService: ScreenManagerService,
    ) {
        this.context = this.authenticationService?.getContextUser();
        this.isMobile =this.screenManagerService.isMobile();
        this.screenManagerService.isMobile$.subscribe(isMobile => {
            this.isMobile = isMobile;
        });
    }

    continue() {
        const terminalId = JSON.parse(this.localStorage.get('terminalId'));
        this.terminalManagementService.selectedTerminal(JSON.parse(this.localStorage.get('terminal')));
        this.router.navigateByUrl(`main-app/aggregator/terminal-information/assign/${terminalId}/terminal-writeoff`);
        this.modalService?.closeAll();
        this.cancelModal();
    }

    cancelModal(shouldProceedToNextView = false) {
        this.closeModal.emit(shouldProceedToNextView);
    }

    public get shouldShowOptionalDescription(): boolean {
        return this.optionalDescription?.templateRef && this.context === 'aggregators';
    }
}
